<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .bottom{
    position: absolute;
    width: 100%;
    background-color: #f5f5f5;
    /*height: 134px;*/
    padding-top: 70px;
    padding-bottom:30px;
    border-top: 1px solid #afafaf;
  }
  .bottom p{
    font-size: 14px;
    color: #232323;
    text-align: center;
    padding: 5px;
  }
</style>
<template>
  <div class="bottom">
    <div style="width: 1200px; margin: 0 auto;"><img src="../assets/img/bottomImg.jpg" alt=""/></div>
    <p >
        <a href="">关于我们 |</a>
        <!--<a href="">广告指南 |</a>-->
        <!--<a href="">人才招聘 |</a>-->
        <!--<a href="">友情链接 |</a>-->
        <a href="">联系我们</a>
        <!--<a href="">意见反馈</a>-->
      </p>
    <p>
      <a href="">联系电话：010-64706970</a>
      <a href="">反馈邮箱：chenchen@utntc.com</a>
      <a href="">北京优时光网络科技有限公司</a>
    </p>
    <p><a target="_blank" rel="nofollow" href="https://beian.miit.gov.cn/">京ICP备18019735号-4</a></p>
  </div>
</template>

<script>
  export default {
    name: 'Bottom',
    data () {
      return {

      }
    }
  }
</script>





// WEBPACK FOOTER //
// src/components/Bottom.vue